<script>
import { useEventBus } from '@/components/order-vue/stores/eventBus.js';

export default {
	data() {
		return {
			message: '',
		};
	},

	mounted() {
		useEventBus().subscribe('o2k:orderStore:orderRegisterError', this.handleOrderRegisterError.bind(this));
	},

	methods: {
		handleOrderRegisterError(event) {
			this.message = event.data.message;
		}
	},
};
</script>

<template>
	<p v-bind="$attrs" v-html="message"></p>
</template>
